// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentLink-m_KAhVZEoKd2bnFHRUoHXi{
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.PaymentLink-m_iIYZZJWVP0eBGSEb1z_Z {
  width: auto;
  display: inline-block;
  text-decoration: none;
}

.PaymentLink-m_iIYZZJWVP0eBGSEb1z_Z span {
  border-radius: 5px;
  padding: 1rem;
  background-color: var(--pps-blue);
  color: white;
  display: block;
}

.PaymentLink-m_iIYZZJWVP0eBGSEb1z_Z span:hover {
  filter: brightness(1.2);
}

.PaymentLink-m_iIYZZJWVP0eBGSEb1z_Z span:active {
  filter: brightness(0.8);
}

.PaymentLink-m_iIYZZJWVP0eBGSEb1z_Z span > :first-child {
    font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./client/login/PaymentLink/PaymentLink.m.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".buttonContainer{\n  display: flex;\n  justify-content: center;\n  margin-bottom: 2rem;\n}\n\n.viewInvoiceIcon {\n  width: auto;\n  display: inline-block;\n  text-decoration: none;\n}\n\n.viewInvoiceIcon span {\n  border-radius: 5px;\n  padding: 1rem;\n  background-color: var(--pps-blue);\n  color: white;\n  display: block;\n}\n\n.viewInvoiceIcon span:hover {\n  filter: brightness(1.2);\n}\n\n.viewInvoiceIcon span:active {\n  filter: brightness(0.8);\n}\n\n.viewInvoiceIcon span > :first-child {\n    font-size: 2rem;\n}"],"sourceRoot":""}]);
// Exports
export var buttonContainer = `PaymentLink-m_KAhVZEoKd2bnFHRUoHXi`;
export var viewInvoiceIcon = `PaymentLink-m_iIYZZJWVP0eBGSEb1z_Z`;
export default ___CSS_LOADER_EXPORT___;
